export const LocalesList = ["en", "da", "de", "fr", "ro", "uk", "be", "nl"] as const;

export type LocaleType = (typeof LocalesList)[number];

export type LocaleMap<T> = {
  [key in LocaleType]: T;
};

export const Locales = {
  EN: "en",
  DA: "da",
  DE: "de",
  FR: "fr",
  RO: "ro",
  UK: "uk",
  BE: "be",
  NL: "nl",
} as const;
